import React from "react";
import { Button } from "@headlessui/react";
import { Navigate } from "ellipse/navigate/Navigate";

export interface IndexButtonsProps {}

const IndexButtons: React.FC<IndexButtonsProps> = (props: IndexButtonsProps) => {

	const goToProducts = () => {
		Navigate.updateQueryParam("page", "products");
	};

	const goToServices = () => {
		Navigate.updateQueryParam("page", "services");
	};

	const goToLearnMore = () => {
		Navigate.updateQueryParam("page", "about");
	};

	return (
		<div id="indexbuttons-container" className="flex flex-col space-y-4 space-x-0 md:flex-row md:flex-wrap md:space-y-0 md:space-x-4">
			<Button id="indexbuttons-portfolio-button" className="rounded-md px-4 py-2" onClick={goToProducts}>
				Products
			</Button>
			<Button id="indexbuttons-development-services-button" className="rounded-md px-4 py-2" onClick={goToServices}>
				Development Services
			</Button>
			<span id="indexbuttons-learn-more-text" className="py-2 cursor-pointer" onClick={goToLearnMore}>
				Learn more
			</span>
		</div>
	);

};

export default IndexButtons;